import React from 'react';
import { Instagram, ExternalLink } from 'lucide-react';

type SocialLinksProps = {
  variant?: 'footer' | 'page';
  className?: string;
};

const SOCIAL_LINKS = [
  {
    name: 'X',
    label: 'Follow Ballotr on X',
    href: 'https://x.com/joinballotr',
  },
  {
    name: 'Instagram',
    label: 'Follow Ballotr on Instagram',
    href: 'https://www.instagram.com/joinballotr/',
  },
  {
    name: 'Bluesky',
    label: 'Follow Ballotr on Bluesky',
    href: 'https://bsky.app/profile/ballotr.com',
  },
];

const SocialLinks: React.FC<SocialLinksProps> = ({
  variant = 'footer',
  className = '',
}) => {
  const isFooter = variant === 'footer';

  return (
    <div className={className}>
      <h3
        className={`font-semibold text-textPrimary ${
          isFooter ? 'text-sm mb-3' : 'text-xl mb-4'
        }`}
      >
        Follow Ballotr
      </h3>

      <div className={`flex ${isFooter ? 'flex-wrap gap-3' : 'flex-col gap-4'}`}>
        {SOCIAL_LINKS.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.label}
            className={
              isFooter
                ? 'inline-flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-textSecondary hover:text-primary hover:border-primary transition'
                : 'inline-flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 text-base font-medium text-textPrimary hover:border-primary hover:text-primary transition shadow-sm'
            }
          >
            <span className="flex items-center gap-2">
              {link.name === 'Instagram' ? (
                <Instagram className="h-4 w-4" />
              ) : (
                <span className="text-sm font-semibold">{link.name}</span>
              )}
              <span>{link.label}</span>
            </span>

            {!isFooter && <ExternalLink className="h-4 w-4 shrink-0" />}
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;